import { createContext, useState, useEffect } from "react";
import useConfig from "../hooks/useConfig";

export const PermissionContext = createContext({
  permissions: [],
  updatePermissions: () => {},
  clearPermissions: () => {},
});

export const PermissionProvider = ({ children }) => {
  const config = useConfig();
  const [permissions, setPermissions] = useState(() => {
    try {
      const storedPermissions = localStorage.getItem(config?.permissionsKey);
      return storedPermissions ? JSON.parse(storedPermissions) : [];
    } catch (error) {
      console.error("Failed to load permissions from localStorage", error);
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(config?.permissionsKey, JSON.stringify(permissions));
    } catch (error) {
      console.error("Failed to save permissions to localStorage", error);
    }
  }, [permissions]);

  const updatePermissions = (newPermissions) => {
    newPermissions = newPermissions;
    setPermissions(newPermissions);
  };

  const clearPermissions = () => {
    setPermissions([]);
    localStorage.removeItem(config?.permissionsKey);
  };

  return (
    <PermissionContext.Provider
      value={{ permissions, updatePermissions, clearPermissions }}
    >
      {children}
    </PermissionContext.Provider>
  );
};
